const getUser = state => state.user || {};
const getProfile = state => getUser(state).profile || {};
const isLoading = state => getUser(state).loading;

const getCustomerId = state => getProfile(state).customerId;
const getUserId = state => getProfile(state).uid;
const getDisplayUid = state => getProfile(state).displayUid;
const getEmployeeFlag = state => getProfile(state).employeeFlag;
const getDefaultAddress = state => getProfile(state).defaultAddress || {};
const getDefaultBillingAddress = state => getProfile(state).defaultBillingAddress || {};
const getUserCountry = state =>
    getDefaultAddress(state).country && getDefaultAddress(state).country.isocode;
const getUserEmail = state => getDefaultAddress(state).email;
const getUserFirstName = state => getDefaultAddress(state).firstName;
const getUserLastName = state => getDefaultAddress(state).lastName;
const getUserPhone = state => getDefaultAddress(state).mobileNumber;
const getUserGender = state => getDefaultAddress(state).gender;
const getUserPostalCode = state => getDefaultAddress(state).postalCode || '';
const getPersonalInformation = state => getProfile(state).personalInformation || {};
const isPregnant = state => getPersonalInformation(state).pregnant;
const isBabyBorn = state => getPersonalInformation(state).babyborn;
const getPregancyDueDate = state => getPersonalInformation(state).pregnancyDueDate;
const getDateOfBirth = state => getPersonalInformation(state).dateOfBirth;
const getChildren = state => getPersonalInformation(state).children || [];
const getLoyaltyInformation = state => getProfile(state).loyaltyInformation || {};
const getPointsBalance = state => getLoyaltyInformation(state).pointsBalance;
const getCardNumber = state => getLoyaltyInformation(state).cardNumber || '';
const isAnonymous = state => getProfile(state).anonymous;
const isLoyalty = state => getProfile(state).loyalty;
const getPrivacyPolicy = state => getProfile(state).privacyPolicyInformation || {};
const getCustomerStatusDelay = state => getUser(state).customerStatusDelay;
const getCustomerStatusRetry = state => getUser(state).customerStatusRetry;
const getCustomerStatusBeforeAttemptDelay = state =>
    getUser(state).customerStatusBeforeAttemptDelay;
const getStatusRetryAttempts = state => getUser(state).statusRetryAttempts;
const isPendingSubscription = state => getUser(state).pendingSubscription;
const getLanguageIsoCode = state => (getProfile(state).language || {}).isocode;
const isRegisteredOnCheckout = state => getUser(state).isRegisteredOnCheckout;
const getUserPopoverInfo = state => getUser(state).showUserPopoverInfo;
const getPreferencesInformation = state => getProfile(state).preferencesInformation || {};
const getDismissedBirthDatePopup = state =>
    getPreferencesInformation(state).dismissedBirthDatePopup;
const getLoyaltyCheques = state => getUser(state).loyaltyCheques;
const _findLoyaltyCheque = (state, number) =>
    getLoyaltyCheques(state).find(el => el.loyaltyNumber === number) || {};
const getErrorOfLoyaltyCheque = (state, number) =>
    _findLoyaltyCheque(state, number).errorMessage || null;
const getStatusForNonVerifiedCustomer = state => getUser(state).enableForNonVerifiedUser;
export const getDisableLoyaltyVouchers = state => getUser(state).disableLoyaltyVouchers || false;
const isVip = state => getUser(state).isVip;
const getVipProgramInformation = state => getProfile(state).vipProgramInformation || {};
const getCustomerCRMInformation = state => getProfile(state).crmInformation || {};
const getCustomerSegment = state => getCustomerCRMInformation(state).crmSegments || [];
const getLastInterestSelectionTime = state => getProfile(state).lastInterestSelectionTime || '';

export default {
    getUser,
    getProfile,
    getCustomerId,
    getUserPostalCode,
    getPersonalInformation,
    isPregnant,
    isBabyBorn,
    getPregancyDueDate,
    getCardNumber,
    getDateOfBirth,
    getChildren,
    getDefaultAddress,
    getUserCountry,
    getLoyaltyInformation,
    getPointsBalance,
    isAnonymous,
    isLoyalty,
    isLoading,
    getPrivacyPolicy,
    getCustomerStatusDelay,
    getCustomerStatusRetry,
    getCustomerStatusBeforeAttemptDelay,
    getStatusRetryAttempts,
    getUserId,
    getDisplayUid,
    getEmployeeFlag,
    isPendingSubscription,
    getLanguageIsoCode,
    isRegisteredOnCheckout,
    getDismissedBirthDatePopup,
    getUserPopoverInfo,
    getLoyaltyCheques,
    getErrorOfLoyaltyCheque,
    getStatusForNonVerifiedCustomer,
    getDisableLoyaltyVouchers,
    isVip,
    getVipProgramInformation,
    getDefaultBillingAddress,
    getCustomerSegment,
    getLastInterestSelectionTime,
    getUserEmail,
    getUserFirstName,
    getUserLastName,
    getUserPhone,
    getUserGender,
};
